import React from "react";
import { NovaThinkingLoader } from "./NovaChatOptions";

const NovaAiLoader = ({ bottomRef }) => {
  return (
    <div ref={bottomRef}>
      <NovaThinkingLoader />
    </div>
  );
};

export default NovaAiLoader;
